import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const PencilOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function PencilOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M21.236 2.765a3.501 3.501 0 0 0-2.47-1.03 3.5 3.5 0 0 0-2.48 1.03l-14.51 14.51-.04 4.99 4.99-.04 14.51-14.51a3.495 3.495 0 0 0 0-4.95Zm-15.35 17.47-2.14.02.02-2.14 10.95-10.95 2.12 2.12-10.95 10.95Zm13.94-13.93-1.57 1.57-2.12-2.12 1.57-1.57a1.499 1.499 0 0 1 2.12 0c.58.58.58 1.54 0 2.12Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default PencilOutlined;